const LIST_URL = "/v1/offer/list";
const SINGLE_URL = "/v1/offer/single";
const ADD_URL = "/v1/offer/add";
const UPDATE_URL = "/v1/offer/update";
const DELETE_URL = "/v1/offer/delete";
const APPROVE_URL = "/v1/offer/approve";

const OFFER_API_URL_LIST = {
    LIST_URL,
    SINGLE_URL,
    ADD_URL,
    UPDATE_URL,
    DELETE_URL,
    APPROVE_URL
}

export { OFFER_API_URL_LIST };